export const baseURL = "https://teenpatti.maalivepartyapp.com/";
export const adminBaseURL = "https://admin.maalivepartyapp.com/";
export const key = "4cb&r7dea0$nd$*$+*a(a$^x+z";